import React from 'react';
import { Table, Form } from 'react-bootstrap';
import { useTranslation } from '../../i18n';

const PlannedVsCompletedSwimming = ({ planned, completed, setPlanned }) => {
  const { t } = useTranslation();

  const fields = [
    { field: 'duracion',    label: t('swimming.durationField'),  unit: 'h:mm:ss'  },
    { field: 'distancia',   label: t('swimming.distanceField'),  unit: 'mts'      },
    { field: 'ritmo_medio', label: t('swimming.avgPaceField'),   unit: 'min/100m' },
    { field: 'calorias',    label: t('swimming.caloriesField'),  unit: 'kcal'     },
    { field: 'tte',         label: 'TTE',                        unit: ''         },
    { field: 'tea',         label: 'TEA',                        unit: ''         },
    { field: 'tss',         label: 'TSS',                        unit: ''         },
  ];

  return (
    <div>
      <h5 className="text-warning mb-3">{t('swimming.plannedVsCompleted')}</h5>
      <Table striped bordered hover>
        <thead style={{ backgroundColor: '#f7941d', color: '#fff' }}>
          <tr>
            <th>{t('swimming.metric')}</th>
            <th>{t('swimming.planned')}</th>
            <th>{t('swimming.completed')}</th>
            <th>{t('swimming.unit')}</th>
          </tr>
        </thead>
        <tbody>
          {fields.map(({ field, label, unit }) => (
            <tr key={field}>
              <td>{label}</td>
              <td>
                <Form.Control
                  type="text"
                  value={planned[field] || ''}
                  onChange={(e) => setPlanned({ ...planned, [field]: e.target.value })}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  readOnly
                  value={completed?.[field] !== undefined && completed?.[field] !== null ? completed[field].toString() : ''}
                />
              </td>
              <td>{unit}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default PlannedVsCompletedSwimming;
